const axios = require('axios');

(() => {
  const registerCreditcardButton = '.register-creditcard-button';
  const updateCreditcardButton = '.update-creditcard-button';
  const deleteCreditcardButton = '.delete-creditcard-button';
  const creditcardIndexPath = process.env.JS_BASE_URL + 'customer/mypage/creditcard';

  const init = () => {
    $('body')
      .on('click', registerCreditcardButton, registerCreditcard)
      .on('click', updateCreditcardButton, registerCreditcard)
      .on('click', deleteCreditcardButton, deregisterCreditcard);
    const memberId = $('#data-current-user-member-id').data('member')
    if (location.pathname === creditcardIndexPath && memberId !== null) {
      inquiryRegisteredCreditcardInfo();
    }
  }

  const registerCreditcard = e => {
    e.preventDefault();
    $(registerCreditcardButton).addClass('disabled').prop('disabled', true);
    const holderName = $('.holder-name-js').val();
    const cardNumber = $('.card-number-js').val();
    const cardNumberString = String(cardNumber);
    const ExpirationMonth = $('.card-expiration-month-js').val();
    const ExpirationYear = $('.card-expiration-year-js').val();
    const securityCode = $('.security-code-js').val();
    const securityCodeString = String(securityCode);
    const twoDigitExpirationMonth = ('0' + ExpirationMonth).slice(-2)
    let expireYymm = String(ExpirationYear) + String(twoDigitExpirationMonth);

    var gmoShopId = gon.gmo_shop_id;
    Multipayment.init(gmoShopId);
    Multipayment.getToken({
      cardno : cardNumberString,
      expire : expireYymm,
      securitycode : securityCodeString,
      holdername : holderName,
    }, (response) => {
      if (response.resultCode != '000') {
        $(registerCreditcardButton).removeClass('disabled').prop('disabled', false);
        alert('クレジットカードが無効です');
      } else {
        let token = response.tokenObject.token;
        if (location.pathname.indexOf('customer/mypage/camping_subscription/credit_card') >= 0) {
          $('#js-creditcard-token').val(token)
          $('form').submit()
          return
        }
        var targetUrl = process.env.JS_BASE_URL + 'customer/mypage/creditcard';
        axios.defaults.headers['X-CSRF-TOKEN'] = $('meta[name=csrf-token]').attr('content')
        axios.post(targetUrl, {
          creditcard_token: token
        }).then(response => {
          if (response.status === 200) {
            if (e.target.className == 'btn register-creditcard-button disabled') {
              window.location.href = process.env.JS_BASE_URL + 'customer/mypage/creditcard/complete?process=create';
            } else {
              window.location.href = process.env.JS_BASE_URL + 'customer/mypage/creditcard/complete?process=update';
            }
          }
        }).catch((error) => {
          $(registerCreditcardButton).removeClass('disabled').prop('disabled', false);
          alert('登録に失敗しました。再度お試し下さい');
        });
      }
    })
  }

  const inquiryRegisteredCreditcardInfo = () => {
    const targetUrl = process.env.JS_BASE_URL + 'api/v1/inquiry_creditcard_registrations';
    axios.get(targetUrl).then(response => {
      if (response.status === 200) {
        const cardNo = response.data.card_info.CardNo;
        const expire = response.data.card_info.Expire;
        const holderName = response.data.card_info.HolderName;
        const expireYear = '20' + String(expire.substr(0, 2));
        const expireMonth = expire.substr(2, 4);
        $('#registered_creditcard_cardno').prepend(`<p>${cardNo}</p>`);
        $('#registered_creditcard_expire').prepend(`<p>有効期限 ${expireMonth}/${expireYear}</p>`);
        $('#registered_creditcard_holdername').prepend(`<p>${holderName}</p>`);
      }
    }).catch(error => {
      console.log(error);
    })
  }

  const deregisterCreditcard = e => {
    e.preventDefault();
    if (!window.confirm('このクレジットカードの登録を解除しますか？\nこの操作は取り消すことができません。')) { return }
    const targetUrl = process.env.JS_BASE_URL + 'api/v1/inquiry_creditcard_registrations';
    axios.defaults.headers['X-CSRF-TOKEN'] = $('meta[name=csrf-token]').attr('content')
    axios.delete(targetUrl).then(response => {
      if (response.status === 200) {
        window.location.href = process.env.JS_BASE_URL + 'customer/mypage/creditcard/complete?process=deregister';
      }
    }).catch(error => {
      console.log(error);
    })
  }
  $(init);
})();
